module.exports = __webpack_public_path__ + "img/jg4.e4f74a0c.png";